<template>
    <section class="container">
      <div class="route">
        {{$locales.ajustes.ajustes}} > {{$locales.ajustes.seguridadclaves.seguridadclaves}} > {{$locales.ajustes.seguridadclaves.modificarpassword}}
      </div>
      <div class="sidebar">
        <span class="principal">
          <span class="icon">J  </span>{{$locales.ajustes.ajustes}}
        </span>
        <ul>
          <li @click="toggle">
            <span class="sidebar-item"><span class="arrow">&#9660;</span>  {{$locales.ajustes.alertas.alertas}}</span>
                <router-link to="/onesaitConfirmingProviders/ajustes/alertas/facturas"  class="link" v-if="active">
                  {{$locales.ajustes.alertas.facturas}}
                </router-link>
          </li>
          <li  @click="toggle2">
                <span class="sidebar-item">
                  <span class="arrow">&#9660; </span>{{$locales.ajustes.seguridadclaves.seguridadclaves}}
                </span>
                <span @click="refresh"><router-link to="/onesaitConfirmingProviders/ajustes/modificar-contrasena" class="link-active" v-if="active2">
                {{$locales.ajustes.seguridadclaves.modificarpassword}}
                </router-link></span>
                <router-link to="/onesaitConfirmingProviders/ajustes/modificar-claveFirma"  class="link" v-if="active2">
                {{$locales.ajustes.seguridadclaves.modificarclavefirma}}
                </router-link>
          </li>
          <li @click="toggle3">
                 <span class="sidebar-item">
                  <span class="arrow">&#9660; </span>{{$locales.ajustes.datospersonales.datospersonales}}
                </span>
                <router-link to="/onesaitConfirmingProviders/ajustes/datos-personales/modificar-datos"  class="link" v-if="active3">
                  {{$locales.ajustes.datospersonales.modificardatos}}
                </router-link>
          </li>
        </ul>
      </div>
      <div class="window">
        <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
          <p>check_circle</p>
          <h3>Operación realizada con éxito</h3>
        </div>
        <div class="mensajeError" v-else-if="confirmacion=='KO'">
          <p>cancel</p>
          <h3>{{mensajeError}}</h3>
        </div>
        <h1>{{$locales.ajustes.seguridadclaves.modificarpassword}}</h1>
          <div class="form-group-reduced">
            <form class="window-form" @submit.prevent="aceptar">
                  <label for="actualPass">* Contraseña actual</label>
                  <input :class = "(submitted &&$v.model.actualPass.$invalid)?'inputInvalid':'inputComponent'" maxlength="6" @keypress="numericInput" required :type="textPass1" id="actualPass" name="actualPass" autocomplete="off" v-model="model.actualPass" :disabled="datosOTP"/>
                  <span class="material-icons visibility2" id="eye1" @click="showPassword" v-if="eye1 && !datosOTP">visibility</span>
                  <span class="material-icons visibility2" id="eye1" @click="hidePassword" v-if="!eye1 && !datosOTP">visibility_off</span>
                  <br>
                  <div class="error" v-if="submitted && !$v.model.actualPass.required">Este campo es obligatorio</div>
                  <div class="error" v-if="submitted && !$v.model.actualPass.minLength">El campo debe tener como mínimo 6 caracteres</div>
                  <label for="newPass">* Nueva contraseña</label>
                  <input :class = "(submitted &&$v.model.newPass.$invalid)?'inputInvalid':'inputComponent'" maxlength="6" @keypress="numericInput" required :type="textPass2" id="newPass" name="newPass" autocomplete="off" v-model="model.newPass" :disabled="datosOTP"/>
                  <span class="material-icons visibility2" id="eye2" @click="showPassword" v-if="eye2 && !datosOTP">visibility</span>
                  <span class="material-icons visibility2" id="eye2" @click="hidePassword" v-if="!eye2 && !datosOTP">visibility_off</span>
                  <br>
                  <div class="error" v-if="submitted && !$v.model.newPass.required">Este campo es obligatorio</div>
                  <div class="error" v-if="submitted && !$v.model.newPass.minLength">El campo debe tener como mínimo 6 caracteres</div>
                  <div class="error" v-if="submitted && !$v.model.newPass.differentFromactualPass">El campo no puede tener el mismo valor que el campo Contraseña actual</div>
                  <label for="newPassRep">* Repite la nueva contraseña</label>
                  <input :class = "(submitted && $v.model.newPassRep.$invalid)?'inputInvalid':'inputComponent'" maxlength="6" @keypress="numericInput" required :type="textPass3" id="newPassRep" name="newPassRep" autocomplete="off" v-model="model.newPassRep" :disabled="datosOTP"/>
                  <span class="material-icons visibility2" id="eye3" @click="showPassword" v-if="eye3 && !datosOTP">visibility</span>
                  <span class="material-icons visibility2" id="eye3" @click="hidePassword" v-if="!eye3 && !datosOTP">visibility_off</span>
                  <br>
                  <div class="error" v-if="submitted && !$v.model.newPassRep.required">Este campo es obligatorio</div>
                  <div class="error" v-if="submitted && !$v.model.newPassRep.minLength">El campo debe tener como mínimo 6 caracteres</div>
                  <div class="error" v-if="submitted && !$v.model.newPassRep.sameAsnewPass">El campo debe tener el mismo valor que el campo Nueva contraseña</div>
                  
                  <input class="btnPrimary" type="submit" value="Aceptar" :disabled="isDisabled" v-if=beforeSubmit>
                  <br><hr/>
                  <p id="subTextPassword">
                    <b>Pautas para elegir una contraseña</b><br>
                    <ul class="circulos">
                      <li>Debe tener 6 caracteres.</li>
                      <li>No deben repetirse contraseñas anteriores.</li>
                      <li>No se permiten números consecutivos (Ej: 123456).</li>
                      <li>No se permiten números repetidos (Ej: 111111).</li>
                    </ul>
                  </p>
                  <br>
                  <div v-if=datosOTP>
                    <OTPComponent :params="params" :datosOTP="datosOTP" :llamada="llamada" @aceptar="callBackAceptarOTP" @cancelar="callBackCancelarOTP"></OTPComponent>
                  </div>
            </form>
          </div>
          <!--<div class="botonera" v-if=beforeSubmit>
            <div class="botones">
              <button v-for="num in numeros" v-bind:key="num" class="botonPantalla" @click="tecladoVirtual($event)">{{num}}</button>
            </div>
            <button class="botonBorrar" @click="borrar()">
              Borrar
            </button>
          </div>-->
          <div v-if=datosFirma>
             <SignatureComponent :params="params" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
          </div>
      </div>
      
    </section>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import ModificarContrasena from '../models/ModificarContrasena';
import SignatureComponent from './SignatureComponent';
import OTPComponent from './OTPComponent';  
export default {
    name : 'ChangePasswordComponent',
    data(){
      return{
        numeros:null,
        active: false,
        active2: true,
        active3: false,        
        datosFirma: null,
        submitted: false,
        mensajeError: null,
      eye1:true,
      eye2:true,
      eye3:true,
      textPass1 : "password",
      textPass2 : "password",
      textPass3 : "password",
        params: null,
        datosOTP: null,
        llamada: null,
        beforeSubmit: true,
        confirmacion: null,
        model : new ModificarContrasena()
      }
    },
    components: {
      SignatureComponent,
      OTPComponent
    },
    computed : {
      isDisabled: function() {
        return  !this.model.actualPass || !this.model.newPass || !this.model.newPassRep;
      }
    },
    validations : {
      model : {
        actualPass: {
          required,
          minLength: minLength(6),
        },
        newPass: {
          required,
          minLength: minLength(6),
          differentFromactualPass: function() {
            return (this.model.actualPass!=this.model.newPass);
          }
        },
        newPassRep: {
          required,
          minLength: minLength(6),
          sameAsnewPass: function() {
            return (this.model.newPass==this.model.newPassRep);
          }
        }
      }
    },
    mounted: function(){
      var arrayTeclado=new Array();
      var numActual;
      var i;
      for(i=0;i<10;i){
        numActual=Math.floor(Math.random() * 10);
        if(!arrayTeclado.includes(numActual)){
          arrayTeclado.push(numActual);
          i++;
        }
      }
      this.numeros=arrayTeclado;
    },
    methods: {
      refresh(){ //esto tiene la funcion de refrescar el componente cuando volvemos a clickar sobre el en las NavigationBars
        this.$parent.keyRefresh+=1; //al cambiar la key de esta section que lo abarca todo, vue dispara un update
      },
      numericInput(a) {
      if (a.which < 48 || a.which > 57) {
        a.preventDefault();
      }
    },
    showPassword(cmp) {
      var numero = cmp.srcElement.id.substring(3);
      switch(numero) {
        case "1":
          this.eye1= false;
          this.textPass1 = "text";
          break;
        
        case "2":
          this.eye2= false;
          this.textPass2 = "text";
          break;

        case "3":
          this.eye3= false;
          this.textPass3 = "text";
          break;
      }
      
    },
    hidePassword(cmp) {
      var numero = cmp.srcElement.id.substring(3);
      switch(numero) {
        case "1":
          this.eye1= true;
          this.textPass1 = "password";
          break;
        
        case "2":
          this.eye2= true;
          this.textPass2 = "password";
          break;

        case "3":
          this.eye3= true;
          this.textPass3 = "password";
          break;
      }
    },
      callBackAceptar(confirmacion, result, otp){
        this.beforeSubmit = false;
        if(confirmacion=='KO' && otp==null){ //esto evita que salga el 0096H que simplemente es un indicador de que requiere OTP
          this.confirmacion=confirmacion;
          this.mensajeError=result;
        }else{ //si ya va bien, quitamos los mensajes de error previos con confirmacion=null
          this.confirmacion=null;
          this.datosFirma = null;
          this.datosOTP=otp;
        }
      },
     callBackCancelar(){
         this.beforeSubmit = true;
         this.datosFirma = null;
      },
      callBackAceptarOTP(confirmacion, mensaje, codError){
        this.beforeSubmit = false;
        this.confirmacion = confirmacion;
        this.submitted=false;
        this.mensajeError = mensaje;
        if(confirmacion == "OK") {
          this.callBackCancelarOTP(); //son las instrucciones necesarias para resetear la pantalla como al comienzo
          window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
          });
        } else {
          window.scroll({
              top: 470,
              left: 0,
              behavior: 'smooth'
          });
          if(codError == '095H') { //clave otp incorrecta
          }else if (codError == '089H') {
            this.datosOTP = null;
            this.mensajeError = 'Usuario bloqueado';
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
          }else{ //si es un error distinto del bloqueo de usuario o clave otp incorrecta, la otp se comporta como si la cancelaramos
            this.callBackCancelarOTP();
          }
        }
      },
     callBackCancelarOTP(){
         this.beforeSubmit = true;
         this.submitted=false;
         this.datosOTP = null;
      },
      toggle () {
        this.active = true;
        this.active2 = false;
        this.active3 = false;
      },
      toggle2 () {
        this.active = false;
        this.active2 = true;
        this.active3 = false;
      },
      toggle3 () {
        this.active = false;
        this.active2 = false;
        this.active3 = true;
      },
      /*tecladoVirtual(elemento){
          if(!this.$v.model.actualPass.required){
            this.model.actualPass=elemento.target.innerHTML;
          }else if(!this.$v.model.actualPass.minLength){
            this.model.actualPass+=elemento.target.innerHTML;
          }else if(!this.$v.model.newPass.required){
            this.model.newPass=elemento.target.innerHTML;
          }else if(!this.$v.model.newPass.minLength){
            this.model.newPass+=elemento.target.innerHTML;
          }else if(!this.$v.model.newPassRep.required){
            this.model.newPassRep=elemento.target.innerHTML;
          }else if(!this.$v.model.newPassRep.minLength){
            this.model.newPassRep+=elemento.target.innerHTML;
          }
      },
      borrar(){
        if(!this.$v.model.actualPass.minLength || (this.$v.model.actualPass.minLength && this.model.newPass==null)){
          this.model.actualPass=null;
        }else if(!this.$v.model.newPass.minLength || (this.$v.model.newPass.minLength && this.model.newPassRep==null)){
          this.model.newPass=null;
        }else{
          this.model.newPassRep=null;
        }
      },*/
      aceptar() {
        this.confirmacion=null;
        this.submitted = true;
          this.$v.$touch();
          if(this.$v.$invalid) {
            return false;
          }else {
            const ventana=this;
            const baseURI = '/api-users/users/me/password';
            this.llamada = {
              urlEndpoint : baseURI,
              metodo : 'PUT'
            };
            this.params = {
              currentPassword : this.model.actualPass,
              newPassword: this.model.newPass
            };
            let loader = this.$loading.show();
            this.$http.put(baseURI, this.params)
            .then(() => {
              ventana.confirmacion='OK';
            })
            .catch(error => {
              if(error.response){ 
                if(error.response.status == 400) {
                  if(error.response.data.result.errors[0].errorCode == "096H") {
                    if(error.response.data.result.errors[0].info.type=="OTP"){ //pide pin de OTP
                      ventana.datosOTP = error.response.data.result.errors[0].info;
                    }else{ //pide clave de firma
                      this.datosFirma = error.response.data.result.errors[0].info;
                    }
                    this.beforeSubmit = false;
                  }else{
                          if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                            ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                          }else{ //si no, por defecto
                            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                          }
                          ventana.confirmacion='KO';
                          ventana.beforeSubmit=true;
                          window.scroll({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                          });
                        }
                }else{
                        if(error.response.status=='404'){ //error de conexion o ruta incorrecta
                          ventana.mensajeError='No se ha podido establecer conexión con el servidor';
                        }else{
                          if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                            ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                          }else{ //si no, por defecto
                            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                          }
                        }
                        ventana.confirmacion='KO';
                        ventana.beforeSubmit=true;
                        window.scroll({
                          top: 0,
                          left: 0,
                          behavior: 'smooth'
                        });
                      }
              }else{ //si no, por defecto
                ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
                ventana.confirmacion='KO';
                ventana.beforeSubmit=true;
              }
            })
            .then(function () {
              loader.hide();
            });
          }
      }
    }
}
</script>